var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.amount)?_c('div',{staticClass:"search-product-amount"},[_c('a',{attrs:{"href":"#shop-search-list"}},[_vm._v(_vm._s(_vm.amount)+" "+_vm._s(_vm.$t("searchproductamount.productsfound", null, _vm.locale)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }